<div class="register__page">
    <div class="main--wrapper">
        <!-- Logo -->
        <header>
            <div class="container">
                <div class="reg__title">
                    <div class="w-25">
                        <a role="button" [href]="commonService.landingUrl">
                            <img [src]="commonService?.getOrgWindowObject?.LOGO_URL ? commonService?.getOrgWindowObject?.LOGO_URL : 'assets/images/logo.png'"
                                onerror="this.src='assets/images/logo.png';" class="cursor-pointer logo__image" alt="Logo">
                        </a>
                    </div>
                    <div class="w-75 text-right font-weight-bold">
                        <span class="color-secondary-gray">Registration for</span><br>
                        <h2>{{orgName}}</h2>
                    </div>
                </div>
            </div>
        </header>

        <!-- Form -->
        <div class="container" *ngIf="!showSuccessPage">
            <div class="auth-box--wrapper position-relative" *ngIf="isCodeValid">
                <!-- STEP 1 -->
                <div class="mb-50">
                    <div class="auth-box--title">Personal Information</div>
                    <div class="auth-box--description">
                        Your information will never be shared and will stay secure. This info is used for the
                        PDF report
                        creation
                    </div>
                </div>

                <form #regForm="ngForm" novalidate="novalidate" autocomplete="off">

                    <div class="row">
                        <div class="col-md-12">
                            <div class="form-group">
                                <label>Email</label>
                                <input type="text" class="input input__blue input__large" [(ngModel)]="user.EMAIL"
                                    #EMAIL="ngModel" name="EMAIL" disabled>
                            </div>
                        </div>

                        <div class="col-md-12" *ngIf="!hasPassword">
                            <div class="form-group">
                                <label>Password</label>
                                <input type="password" class="input input__blue input__large" [(ngModel)]="PASSWORD"
                                    #PASSWORD_TXT="ngModel" name="PASSWORD_TXT" required placeholder="Password"
                                    pattern="^(?=.*[A-Za-z])(?=.*\d)(?=.*[$@$!%*#?&])[A-Za-z\d$@$!%*#?&]{8,}$"
                                    [ngClass]="{'input__error': PASSWORD_TXT.errors && (PASSWORD_TXT.dirty || PASSWORD_TXT.touched || PASSWORD_TXT.errors?.pattern)}">
                                    <div *ngIf="PASSWORD_TXT.errors && (PASSWORD_TXT.dirty || PASSWORD_TXT.touched || PASSWORD_TXT.errors?.pattern)">
                                        <div class="error-text">Password must be at least 8 characters with at least 1 number and 1 special character (&#64;, $, !, %, *, #, ?, &)</div>
                                      </div>
                            </div>
                        </div>

                        <div class="col-md-12">
                            <div class="form-group">
                                <label>First Name</label>
                                <input type="text" restrictFirstSpace appAlphabetWithSpaceOnly class="input input__blue input__large" [(ngModel)]="user.NAME_FIRST"
                                    #NAME_FIRST="ngModel" name="NAME_FIRST" required placeholder="First Name"
                                    [ngClass]="{'input__error': (NAME_FIRST.errors && (NAME_FIRST.dirty || NAME_FIRST.touched))}">
                            </div>
                        </div>

                        <div class="col-md-12">
                            <div class="form-group">
                                <label>Last Name</label>
                                <input type="text" restrictFirstSpace appAlphabetWithSpaceOnly class="input input__blue input__large" [(ngModel)]="user.NAME_LAST"
                                    #NAME_LAST="ngModel" name="NAME_LAST" required placeholder="Last Name"
                                    [ngClass]="{'input__error': (NAME_LAST.errors && (NAME_LAST.dirty || NAME_LAST.touched))}">
                            </div>
                        </div>

                        <div class="col-md-12">
                            <div class="form-group">
                                <label>Phone Number</label>
                                <input type="text" restrictFirstSpace phoneNumber class="input input__blue input__large" [(ngModel)]="phoneNumber"
                                    #TELEPHONE="ngModel" name="TELEPHONE" required placeholder="000-000-0000"
                                    [ngClass]="{'input__error': (TELEPHONE.errors && (TELEPHONE.dirty || TELEPHONE.touched))}">
                            </div>
                        </div>

                        <div class="col-md-12">
                          <label class="checkbox m-0">
                            <input type="checkbox" name="IS_AGREE" class="checkbox__input" [value]="true"
                                   [(ngModel)]="IS_AGREE">
                            <div class="checkbox__data pl-0 pt-0">
                              <div class="checkbox__indicator"></div>
                              <p class="checkbox__text white-space-nowrap">
                                By registering you agree to our
                                <a class="color--blue" href="/privacy" target="_blank">privacy policy</a>,&nbsp;
                                <a class="color--blue" href="/license" target="_blank">license</a> &
                                <a class="color--blue" href="/tos" target="_blank">terms and conditions</a>
                              </p>
                            </div>
                          </label>
                          <p class="font-size-13 color--gray--2 mb-1">
                            We will never sell or disclose, nor permit access to, Non-public Personal Information for any purpose other than as specifically required to fulfill our contractual obligations with you.
                          </p>
                          <p class="font-size-14 color--gray--2">
                            By clicking the Register button, you agree to the <a class="color--blue" href="/license" target="_blank">License Agreement</a> (no payment due)
                          </p>
                        </div>

                        <div class="col-md-12">
                            <button type="button" class="button primary__button medium__button px-5" [disabled]="!regForm.valid || !IS_AGREE" (click)="registerUser()">
                              Register
                            </button>
                        </div>

                    </div>


                </form>

            </div>

            <div *ngIf="!isCodeValid" class="alert alert-danger text-center">
                <strong>Invalid Code</strong> <br>
                You have used expired link , user already register please use login.
            </div>
        </div>

        <div class="container" *ngIf="showSuccessPage">
            <div class="position-relative">
                <div class="blueish-bg">
                    <div class="shade upper"></div>
                    <div class="shade lower"></div>
                </div>
                <div class="signup--content">
                    <div class="signup--contentBox success-box">
                        <div>
                            <svg-icon name="email_sent"></svg-icon>
                        </div>
                        <div class="mt-50 mb-10">
                            <h4 class="signup--contentTitle mb-0">Thank you for Registering, you will be redirected to
                                your Dashboard.</h4>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>
